// 分享符号——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `icon/share/index${i + 1}`,
  name: `icon/shareIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/share/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 分享符号——主流程，开始
    ...MainRoutes,
  ],
};
